import styled, { css } from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Config from '@config';
import Radio from '@atoms/Radio/Radio';
import Text from '@atoms/Text/Text';

export const StyledTimeSlotItem = styled.button<{ 'data-selected': boolean }>`
  position: relative;
  background-color: ${variables.colors.white};
  width: 100%;
  border: ${rem(1)} solid ${variables.colors.mediumGray};
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: ${rem(15)};
  font-family: ${variables.fonts.fontGothamMedium};
  padding: ${rem(20)};
  border-radius: ${rem(4)};

  ${Config.MEDIA.IS_MOBILE_SMALL} {
    font-size: ${rem(13)};
  }

  ${(props) =>
    props['data-selected'] &&
    css`
      border-color: ${variables.colors.highlight};
      border-width: ${rem(2)};
      margin: ${rem(-1)};
    `};

  ${(props) =>
    props.disabled &&
    css`
      color: ${variables.colors.darkerGray};
      border-color: ${variables.colors.mediumGray};
      cursor: default;

      &:hover {
        border-color: ${variables.colors.mediumGray} !important;
        border-width: ${rem(1)} !important;
        margin: 0 !important;
      }
    `};

  &:last-child {
    margin-bottom: ${rem(8)};
  }

  &:hover {
    border-color: ${variables.colors.highlight};
    border-width: ${rem(2)};
    margin: ${rem(-1)};
  }
`;

export const StyledSlotTimeText = styled(Text)<{ disabled: boolean }>`
  ${(props) =>
    props.disabled &&
    css`
      text-decoration: line-through;
    `};
`;

export const StyledSlotTextInformation = styled.div`
  display: flex;
  text-align: left;
  width: 100%;
`;

export const StyledSlotTextInformationInnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const StyledSlotTextWrapper = styled.div`
  display: flex;
  gap: ${rem(12)};
  flex-direction: column;
  width: 100%;
`;

export const StyledRadio = styled(Radio)`
  margin-right: ${rem(8)};
`;
